import Page from '@/components/common/page';
import Configurator from '@/components/pricing/configurator';


class ConfiguratorPage extends Page {
    init() {
        this.configurator = new Configurator;
    }
}

export default ConfiguratorPage;
